export default "__VITE_ASSET__BruuXQkb__"